"use client";

import {createLink} from "@gluestack-ui/link";
import type {VariantProps} from "@gluestack-ui/nativewind-utils";
import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {withStyleContext} from "@gluestack-ui/nativewind-utils/withStyleContext";
import {cssInterop} from "nativewind";
import React from "react";
import {Pressable} from "react-native";

import {Text} from "../text";

export const UILink = createLink({
    Root: withStyleContext(Pressable),
    Text
});

cssInterop(UILink, {className: "style"});

const linkStyle = tva({
    base: `
        group/link
        web:outline-0
        data-[disabled=true]:web:cursor-not-allowed
        data-[focus-visible=true]:web:ring-2
        data-[focus-visible=true]:web:ring-indicator-primary
        data-[focus-visible=true]:web:outline-0
        data-[disabled=true]:opacity-4
    `
});

const linkTextStyle = tva({
    base: `
        font-body
        web:my-0
        web:bg-transparent
        web:border-0
        web:box-border
        web:display-inline
        web:list-none
        web:margin-0
        web:padding-0
        web:position-relative
        web:text-start
        web:whitespace-pre-wrap
        web:word-wrap-break-word
    `
});

type ILinkProps = React.ComponentProps<typeof UILink> &
    VariantProps<typeof linkStyle> & {className?: string};

const Link = React.forwardRef<React.ElementRef<typeof UILink>, ILinkProps>(
    ({className, ...props}, ref) => {
        return <UILink ref={ref} {...props} className={linkStyle({class: className})} />;
    }
);

type ILinkTextProps = React.ComponentProps<typeof UILink.Text> &
    VariantProps<typeof linkTextStyle> & {className?: string};

const LinkText = React.forwardRef<React.ElementRef<typeof UILink.Text>, ILinkTextProps>(
    ({className, variant = "sm", ...props}, ref) => {
        return (
            <UILink.Text
                ref={ref}
                variant={variant}
                {...props}
                className={linkTextStyle({
                    class: className
                })}
            />
        );
    }
);

Link.displayName = "Link";
LinkText.displayName = "LinkText";

export {Link, LinkText};
